import { render } from "./PlanTwoView.vue?vue&type=template&id=03c5849a"
import script from "./PlanTwoView.vue?vue&type=script&lang=js"
export * from "./PlanTwoView.vue?vue&type=script&lang=js"

import "./PlanTwoView.vue?vue&type=style&index=0&id=03c5849a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__